import React, { Component } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import ReactTooltip from "react-tooltip";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import IconInfo from "material-ui/svg-icons/action/info";
import compose from "recompose/compose";
import { ValuesForm } from "../components";
import { TextField } from "redux-form-material-ui";
import Paper from "material-ui/Paper";
import { Card } from "material-ui/Card";
import { Flex, Box } from "rebass";
import {
  Toolbar,
  translate,
  CREATE,
  showNotification as showNotificationAction,
} from "admin-on-rest";
import { push as pushAction } from "react-router-redux";
import { red500 } from "material-ui/styles/colors";

import { ViewTitle, checkNumber } from "../components";
import { DivFormContainer, HeaderTitleCreate } from "./styled";

import { RestClient, RestApiShortUrl } from "../restClient";

const required = (value) => (value == null ? "Required" : undefined);
const email = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "Invalid email"
    : undefined;

class DetailMarketer extends Component {
  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit((values) => {
      this.getSlug(values);
    });

  getSlug = (values) => {
    if (get(values, "nickname", "") === "") {
      this.props.showNotification("Nickname Can not empty", "warning");
    } else {
      RestApiShortUrl(values.nickname)
        .then((response) => {
          if (response.status >= 400) {
            this.props.showNotification("Bad response from server", "warning");
            throw new Error("Bad response from server");
          }
          return response.json();
        })
        .then((data) => {
          if (!data.exists) {
            this.save(values);
          } else {
            this.props.showNotification("The Nickname already have", "warning");
          }
        })
        .catch((e) => {
          this.props.showNotification("Please try again", "warning");
          console.error(e);
        });
    }
  };

  save(values) {
    const url = this.props.match.url;
    console.log("his.props.agency_id", this.props.agency_id);
    console.log("values", JSON.stringify(values));
    console.log("url", JSON.stringify(url));
    RestClient(CREATE, `agencyMarketers/${this.props.agency_id}`, {
      data: values,
    })
      .then((items) => {
        console.log("item", JSON.stringify(items));
        if (items && items.data) {
          const paramsUrl = url.replace("/create", "");
          this.props.showNotification("Element Created");
          this.props.push(paramsUrl);
        } else {
          this.props.showNotification("Please try again", "warning");
        }
      })
      .catch((e) => {
        this.props.showNotification("Please try again", "warning");
        console.log(e);
      });
  }
  renderInfoDetail() {
    return (
      <Paper zDepth={1}>
        <Box w={[1]} p={[1]} pb={[0]}>
          Details
        </Box>
        <Flex w={[1]} p={[1]} wrap direction={["row"]}>
          <Box w={[1, 1 / 2]} p={[1]}>
            <Field
              name='first_name'
              component={TextField}
              hintText='First name'
              floatingLabelText='First name'
              validate={required}
              fullWidth={true}
              ref='first_name'
              withRef
            />
          </Box>
          <Box w={[1, 1 / 2]} p={[1]}>
            <Field
              name='last_name'
              component={TextField}
              hintText='Last name'
              floatingLabelText='Last name'
              validate={required}
              fullWidth={true}
              ref='last_name'
              withRef
            />
          </Box>
          <Box w={[1, 1 / 2]} p={[1]}>
            <Field
              name='nickname'
              component={TextField}
              hintText='Nickname'
              floatingLabelText='Nickname'
              validate={required}
              fullWidth={true}
              ref='nickname'
              withRef
            />
          </Box>
          <Box w={[1, 1 / 2]} p={[1]}>
            <Field
              name='email'
              component={TextField}
              hintText='Google mail'
              floatingLabelText='Google mail'
              validate={[required, email]}
              fullWidth={true}
              ref='email'
              withRef
            />
          </Box>
          <Box w={[1, 1 / 2]} p={[1]}>
            <Field
              name='mobile'
              component={TextField}
              hintText='Mobile'
              floatingLabelText='Mobile'
              validate={required}
              fullWidth={true}
              ref='mobile'
              withRef
            />
          </Box>
          <Flex w={[1, 1 / 2]} p={[1]} direction={["row"]} align={["flex-end"]}>
            <Field
              name='custom4.margin'
              component={TextField}
              hintText='Margin %'
              floatingLabelText='Margin %'
              validate={required}
              fullWidth={true}
              ref='custom4.margin'
              parse={(v) => checkNumber(v)}
              withRef
            />
            <span data-tip='' data-for='margintooltip'>
              <IconInfo style={iconStyles} color={red500} />
            </span>
            <ReactTooltip
              id='margintooltip'
              type='error'
              aria-haspopup='true'
              place='top'
            >
              <span>Margin to be given to the agency </span>
            </ReactTooltip>
          </Flex>
        </Flex>
      </Paper>
    );
  }
  renderInfoSocial() {
    return (
      <Paper zDepth={1}>
        <Box w={[1]} p={[1]} pb={[0]}>
          Social
        </Box>
        <Flex w={[1]} p={[1]} wrap direction={["row"]}>
          <Box w={[1, 1 / 2]} p={[1]}>
            <Field
              name='social.instagram'
              component={TextField}
              hintText='Instagram'
              floatingLabelText='Instagram'
              fullWidth={true}
              ref='social.instagram'
              withRef
            />
          </Box>
          <Box w={[1, 1 / 2]} p={[1]}>
            <Field
              name='social.youtube'
              component={TextField}
              hintText='Youtube'
              floatingLabelText='Youtube'
              fullWidth={true}
              ref='social.youtube'
              withRef
            />
          </Box>
        </Flex>
      </Paper>
    );
  }
  render() {
    const { invalid, submitOnEnter, toolbar } = this.props;
    return (
      <Card containerStyle={{ minHeight: 518 }}>
        <ViewTitle title={<HeaderTitleCreate {...this.props} />} />
        <form className='simple-form'>
          <DivFormContainer w={[1]}>
            <Box w={[1]} py={[1]} px={[2]}>
              {this.renderInfoDetail()}
            </Box>
            <Box w={[1]} py={[1]} px={[2]}>
              {this.renderInfoSocial()}
            </Box>
          </DivFormContainer>
          {toolbar &&
            React.cloneElement(toolbar, {
              handleSubmitWithRedirect: this.handleSubmitWithRedirect,
              invalid,
              submitOnEnter,
            })}
          <ValuesForm isDebug={true} formName={"record-form"} />
        </form>
      </Card>
    );
  }
}

const iconStyles = {
  marginLeft: 16,
  width: 24,
  height: 24,
};

DetailMarketer.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  handleSubmit: PropTypes.func,
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  save: PropTypes.func,
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
  validate: PropTypes.func,
  translate: PropTypes.func,
  push: PropTypes.func,
  showNotification: PropTypes.func,
};

DetailMarketer.defaultProps = {
  submitOnEnter: false,
  toolbar: <Toolbar />,
  translate: translate,
  defaultValue: {
    agency_id: "",
    margin: 0,
  },
};
// const selector = formValueSelector("record-form");
const enhance = compose(
  connect(
    (state, props) => {
      const agency_id = props.match.params.id * 1;
      return {
        initialValues: {
          custom4: {
            agency_id: agency_id,
            margin: 0,
          },
        },
        agency_id,
      };
    },
    {
      showNotification: showNotificationAction,
      push: pushAction,
    }
  ),
  reduxForm({
    form: "record-form",
    enableReinitialize: true,
  })
);

export default enhance(DetailMarketer);



// WEBPACK FOOTER //
// ./src/agency/DetailMarketer.js